class CustomTrackingConsent extends HTMLElement {
  async connectedCallback() {
    this.buttons = [
      'settings-button',
      'accept-button',
      'detail-accept-button',
      'detail-save-button',
    ];

    try {
      await this.waitForSubmitButton();

      this.buttons.forEach((button) => {
        const el = document.querySelector(`[data-cky-tag="${button}"]`);
        if (el) {
          el.addEventListener('click', () => {
            this.setConsent('On submit');
          });
        }
      });
    } catch (err) {
      console.error('Error waiting for submit button:', err);
    }

    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        this.setConsent('On page load');
      }, 3000);
    });
  }

  setConsent(reason) {
    Shopify?.trackingConsent?.setTrackingConsent(true, () => {
      console.log(`Consent set: ${reason}`);
    });
  }

  waitForSubmitButton() {
    return new Promise((resolve, reject) => {
      const button = document.querySelector('[data-cky-tag="accept-button"]');
      if (button) {
        resolve(button);
        return;
      }

      const observer = new MutationObserver(() => {
        const el = document.querySelector('[data-cky-tag="accept-button"]');
        if (el) {
          observer.disconnect();
          clearTimeout(timer);
          resolve(el);
        }
      });

      observer.observe(document, {
        childList: true,
        subtree: true,
      });

      const timer = setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Timed out waiting for ${'[data-cky-tag="accept-button"]'}`));
      }, 10000);
    });
  }
}

customElements.define('custom-tracking-consent', CustomTrackingConsent);
